import axiosLib from 'axios';
import { useAuthStore } from '../store/shared/auth-store';
import { useLayoutStore } from '../store/shared/layout-store';

const api = axiosLib.create({
	baseURL: process.env.BASE_URL,
});

api.interceptors.request.use((config) => {
	const authStore = useAuthStore();
	const layoutStore = useLayoutStore();

	config.headers.Authorization = `Bearer ${authStore.token}`;
	config.headers.locale = layoutStore.lang;
	config.headers.lang = layoutStore.lang;

	return config;
});

export { api };
